import Box from "@mui/material/Box";
import { useQueryClient } from "@tanstack/react-query";
import { useMsalSync } from "auth/useMsalSync";
import { useEffect } from "react";
import { Outlet } from "react-router";

import { useUser } from "../../auth/useUser";
import { useSnackbar } from "../../hooks/useSnackbar";
import { ApiError } from "../../services/apiClient";
import { SignalRProvider } from "../../services/notifications/SignalRProvider";
import { NavigationBar } from "./NavigationBar";

export function AppLayout() {
  useMsalSync();

  const queryClient = useQueryClient();
  const { showSnackbar } = useSnackbar();
  const { user } = useUser();

  useEffect(() => {
    const unsubscribe = queryClient.getQueryCache().subscribe((event) => {
      if (
        event.type === "updated" &&
        event.action.type === "error" &&
        event.action.error instanceof ApiError &&
        event.action.error.status === 403
      ) {
        const role = user?.roles?.join(", ") ?? "okänd";
        showSnackbar(
          `Du saknar behörighet för denna åtgärd. Din roll: ${role}. Kontakta administratör.`,
          "warning",
        );
      }
    });
    return unsubscribe;
  }, [queryClient, showSnackbar, user]);

  return (
    <SignalRProvider>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          // Sticky AppBar only sticks inside a parent as tall as the content.
          flexShrink: 0,
        }}
      >
        <NavigationBar />
        <Box component="main" sx={{ flex: 1, p: 3 }}>
          <Outlet />
        </Box>
      </Box>
    </SignalRProvider>
  );
}
